import React from "react";
import SuperProductForm from "./SuperProductForm";

// Filename keeps its original spelling so the route imports elsewhere in
// the panel keep resolving.
const EditProduct = (props) => (
  <SuperProductForm shopId={props.id} shopName={props.shopName} productId={props.productId} />
);

export default EditProduct;
